<template>
  <div class="columns is-multiline">
      <div class="column is-4">
        <div class="testimonial-box">
          <div class="testimonial-content">
            <p class="testimonial-text">「HStorageの導入により、社内のファイル共有業務が劇的に効率化しました。特にセキュリティ面での安心感は他のサービスでは得られません。」</p>
          </div>
          <div class="testimonial-author">
            <img src="/static/images/testimonial-1.avif" alt="IT企業 CIO" class="testimonial-avatar" width="50"
              height="50">
            <div class="testimonial-info">
              <p class="testimonial-name">鈴木 健太郎 様</p>
              <p class="testimonial-position">大手IT企業 CIO</p>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="testimonial-box">
          <div class="testimonial-content">
            <p class="testimonial-text">「大容量ファイルの転送に悩んでいましたが、HStorageを使うことで問題が解決しました。今では社内標準ツールとして全部署で利用しています。」</p>
          </div>
          <div class="testimonial-author">
            <img src="/static/images/testimonial-2.avif" alt="製造業 部長" class="testimonial-avatar" width="50"
              height="50">
            <div class="testimonial-info">
              <p class="testimonial-name">田中 優子 様</p>
              <p class="testimonial-position">製造業 情報システム部長</p>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="testimonial-box">
          <div class="testimonial-content">
            <p class="testimonial-text">「クライアントとの大容量データのやり取りが多い業種ですが、HStorageのおかげで業務効率が50%以上改善しました。サポートの手厚さも魅力です。」</p>
          </div>
          <div class="testimonial-author">
            <img src="/static/images/testimonial-3.avif" alt="デザイン会社 代表" class="testimonial-avatar" width="50"
              height="50">
            <div class="testimonial-info">
              <p class="testimonial-name">佐藤 一郎 様</p>
              <p class="testimonial-position">デザイン会社 代表取締役</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialsSection'
}
</script>

<style lang="scss" scoped>
/* Testimonials Styles */
.testimonial-box {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 1.5rem;
  height: 100%;
  box-shadow: 0 2px 15px rgba(10, 10, 30, 0.05);
}

.testimonial-content {
  position: relative;
  margin-bottom: 1.5rem;
  font-style: italic;
}

.testimonial-content::before {
  content: '"';
  font-size: 3rem;
  color: rgba(242, 67, 104, 0.2);
  position: absolute;
  top: -1.5rem;
  left: -0.5rem;
}

.testimonial-text {
  position: relative;
  z-index: 1;
}

.testimonial-author {
  display: flex;
  align-items: center;
}

.testimonial-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 1rem;
  object-fit: cover;
}

.testimonial-name {
  font-weight: bold;
  margin-bottom: 0.2rem;
}

.testimonial-position {
  font-size: 0.9rem;
  color: #666;
}

@media screen and (max-width: 768px) {
  .testimonial-box {
    margin-bottom: 1rem;
  }
}
</style>